import { render, staticRenderFns } from "./MessageNPSViewSidebar.vue?vue&type=template&id=bb47ba46&scoped=true"
import script from "./MessageNPSViewSidebar.vue?vue&type=script&lang=js"
export * from "./MessageNPSViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./MessageNPSViewSidebar.vue?vue&type=style&index=0&id=bb47ba46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb47ba46",
  null
  
)

export default component.exports